import { render, staticRenderFns } from "./EditParticipantRelationshipsForm.vue?vue&type=template&id=3000f153&"
import script from "./EditParticipantRelationshipsForm.vue?vue&type=script&lang=js&"
export * from "./EditParticipantRelationshipsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports